import {getActionType, TYPES} from '../util/redux';
import {PlanType, PAGESIZE} from '../action/plan';

import { propEq } from '../util/tool';


const initState = {
  data0: [],
  data1: {
    total: 0,
    page: 1
  },
  data2: {
    total: 0,
    page: 1
  },
  overview: {
    earningsAmount0: 0,
    earningsAmount1: 0,
    earningsDate0: 0,
    canWithdrawAmount: 0,
    earningsMsg: false
  },
  date: null,
  msg1: '',
  msg2: '',
  msg3: '', // earnings
  msg4: '', // withdraw
  msg0: '',
  bankInfo: {},
  bankInfoRequesting: false,
  bankInfoStatus: {
    code: null,
    msg: null
  },
  // 比率
  coefficient: null
}


const EARNING_LIST_SUCCESS = getActionType(PlanType, 'earningListSuccess');
const WITHDRAW_LIST_SUCCESS = getActionType(PlanType, 'withdrawListSuccess');
const EARN_OVERVIEW_SUCCESS = getActionType(PlanType, 'earnOverviewSuccess');
const WITHDRAW_OVERVIEW_SUCCESS = getActionType(PlanType, 'withdrawOverviewSuccess');
const REQUEST_FAIL = getActionType(PlanType, 'requestFail');
const BANKCARD_REQUEST = getActionType(PlanType, 'bankcardRequest');


export default function planReducer(state = initState, action) {
  let { type, payload } = action;
  let odata = {}, page;
  switch(type) {
    case EARNING_LIST_SUCCESS:
      odata = state['data1'];
      page = payload.page || 1;
      odata[page] = payload.list;
      odata.total = payload.total;
      return {
        ...state,
        data1: odata,
        msg1: ''
      }
    case WITHDRAW_LIST_SUCCESS:
      odata = state['data2'];
      page = payload.page || 1;
      odata[page] = payload.list;
      odata.total = payload.total;
      return {
        ...state,
        data2: odata,
        msg2: ''
      }
    case EARN_OVERVIEW_SUCCESS:
      const data1 = payload.list.find(propEq('type', 1));
      const data2 = payload.list.find(propEq('type', 2));
      const data3 = payload.list.find(propEq('type', 3)); 
      const data4 = payload.list.find(propEq('type', 4)); 
      const date = payload.date;
      const canWithdrawAmount = data4.earningsAmount;
      const coefficient = payload.coefficient;
      const companyUser = payload.companyUser;
      const videoIncome = payload.videoIncome;
      // 收益计算中
      if (data3) {
        odata.earningsMsg = '收益计算中';
        odata.earningsDate0 = null;
        odata.earningsAmount1 = data1 ? data1.earningsAmount : '0.00';
        odata.canWithdrawAmount = canWithdrawAmount;
        return {
          ...state,
          overview: {...state.overview, ...odata},
          msg3: '',
          date,
          coefficient,
          companyUser,
          videoIncome
        }
      }
      // 收益计算完毕
      else {
        odata.earningsAmount1 = data1.earningsAmount;
        odata.earningsAmount0 = data2.earningsAmount;
        odata.earningsDate0 = data2.earningsDate;
        odata.earningsMsg = false;
        odata.canWithdrawAmount = canWithdrawAmount;
        return {
          ...state,
          overview: {...state.overview, ...odata},
          msg3: '',
          date,
          coefficient,
          companyUser,
          videoIncome
        }
      }
     
    case WITHDRAW_OVERVIEW_SUCCESS:
      // odata.canWithdrawAmount = payload.list.canWithdrawAmount;
      const bankInfo = payload.list.bankCardInfo;
      const sdata = {code: payload.list.errorCode, msg: payload.list.errorMes}
      return {
        ...state,
        // overview: {...state.overview, ...odata},
        msg4: '',
        bankInfo: bankInfo,
        bankInfoStatus: sdata
      }
    case REQUEST_FAIL:
    case BANKCARD_REQUEST:
      return {
        ...state,
        ...payload
      }
    default: 
      return state;
  }
}


// WEBPACK FOOTER //
// ./client/reducers/plan.js